import paymentConfigTypes from './types';

const initialState = {
  importingBankAccounts: false,
  allConfigs: null,
  fetchingAllconfigurations: true,
  paystack: [],
  fetchingPaystackConfig: false,
  fetchingNabrollConfig: false,
  remita: null,
  nabroll: null,
  payproKano: null,
  payUnimaid: null,
  fetchingPayUnimailConfig: false,
  fetchingPayproKanoConfig: false,
  fetchingRemitaConfig: false,
  interSwitch: null,
  fetchingInterswitchConfig: false,
  deletingConfig: false,
  updatingConfig: false,
  error: null,
};

function workflowsReducer(state = initialState, { type, payload }) {
  switch (type) {
    case paymentConfigTypes.FETCH_PAYMENT_CONFIG_REQUEST:
      return {
        ...state,
        fetchingAllconfigurations: true,
      };
    case paymentConfigTypes.FETCH_PAYMENT_CONFIG_SUCCESS:
      return {
        ...state,
        fetchingAllconfigurations: false,
        allConfigs: payload,
      };
    case paymentConfigTypes.FETCH_PAYMENT_CONFIG_FAILURE:
      return {
        ...state,
        fetchingAllconfigurations: false,
        error: payload,
      };
    case paymentConfigTypes.FETCH_PAYSTACK_CONFIG_REQUEST:
      return {
        ...state,
        fetchingPaystackConfig: true,
      };
    case paymentConfigTypes.FETCH_PAYSTACK_CONFIG_SUCCESS:
      return {
        ...state,
        fetchingPaystackConfig: false,
        paystack: payload,
      };
    case paymentConfigTypes.FETCH_PAYSTACK_CONFIG_FAILURE:
      return {
        ...state,
        fetchingPaystackConfig: false,
        error: payload,
      };
    case paymentConfigTypes.FETCH_REMITA_CONFIG_REQUEST:
      return {
        ...state,
        fetchingRemitaConfig: true,
      };
    case paymentConfigTypes.FETCH_REMITA_CONFIG_SUCCESS:
      return {
        ...state,
        fetchingRemitaConfig: false,
        remita: payload,
      };
    case paymentConfigTypes.FETCH_REMITA_CONFIG_FAILURE:
      return {
        ...state,
        fetchingRemitaConfig: false,
        error: payload,
      };
    case paymentConfigTypes.FETCH_NABROLL_CONFIG_REQUEST:
      return {
        ...state,
        fetchingNabrollConfig: true,
      };
    case paymentConfigTypes.FETCH_NABROLL_CONFIG_SUCCESS:
      return {
        ...state,
        fetchingNabrollConfig: false,
        nabroll: payload,
      };
    case paymentConfigTypes.FETCH_NABROLL_CONFIG_FAILURE:
      return {
        ...state,
        fetchingNabrollConfig: false,
        error: payload,
      };
    case paymentConfigTypes.FETCH_PAYPRO_KANO_CONFIG_REQUEST:
      return {
        ...state,
        fetchingPayproKanoConfig: true,
      };
    case paymentConfigTypes.FETCH_PAYPRO_KANO_CONFIG_SUCCESS:
      return {
        ...state,
        fetchingPayproKanoConfig: false,
        payproKano: payload,
      };
    case paymentConfigTypes.FETCH_PAYPRO_KANO_CONFIG_FAILURE:
      return {
        ...state,
        fetchingPayproKanoConfig: false,
        error: payload,
      };
    case paymentConfigTypes.FETCH_PAYUNIMAID_CONFIG_REQUEST:
      return {
        ...state,
        fetchingPayUnimailConfig: true,
      };
    case paymentConfigTypes.FETCH_PAYUNIMAID_CONFIG_SUCCESS:
      return {
        ...state,
        fetchingPayUnimailConfig: false,
        payUnimaid: payload,
      };
    case paymentConfigTypes.FETCH_PAYUNIMAID_CONFIG_FAILURE:
      return {
        ...state,
        fetchingPayUnimailConfig: false,
        error: payload,
      };
    case paymentConfigTypes.FETCH_INTERSWITCH_CONFIG_REQUEST:
      return {
        ...state,
        fetchingInterswitchConfig: true,
      };
    case paymentConfigTypes.FETCH_INTERSWITCH_CONFIG_SUCCESS:
      return {
        ...state,
        fetchingInterswitchConfig: false,
        interSwitch: payload,
      };
    case paymentConfigTypes.FETCH_INTERSWITCH_CONFIG_FAILURE:
      return {
        ...state,
        fetchingInterswitchConfig: false,
        error: payload,
      };
    case paymentConfigTypes.IMPORT_PAYMENT_CONFIG_REQUEST:
      return {
        ...state,
        importingBankAccounts: true,
      };
    case paymentConfigTypes.IMPORT_PAYMENT_CONFIG_SUCCESS:
      return {
        ...state,
        importingBankAccounts: false,
      };
    case paymentConfigTypes.IMPORT_PAYMENT_CONFIG_FAILURE:
      return {
        ...state,
        importingBankAccounts: false,
        error: payload,
      };
    case paymentConfigTypes.DELETE_PAYMENT_CONFIG_REQUEST:
      return {
        ...state,
        deletingConfig: true,
      };
    case paymentConfigTypes.DELETE_PAYMENT_CONFIG_FAILURE:
      return {
        ...state,
        deletingConfig: false,
        error: payload,
      };
    case paymentConfigTypes.DELETE_PAYSTACK_PAYMENT_CONFIG_SUCCESS:
      return {
        ...state,
        deletingConfig: false,
        paystack: null,
      };
    case paymentConfigTypes.DELETE_INTERSWITCH_PAYMENT_CONFIG_SUCCESS:
      return {
        ...state,
        deletingConfig: false,
        interSwitch: null,
      };
    case paymentConfigTypes.DELETE_REMITA_PAYMENT_CONFIG_SUCCESS:
      return {
        ...state,
        deletingConfig: false,
        remita: null,
      };
    case paymentConfigTypes.UPDATE_PAYMENT_CONFIG_REQUEST:
      return {
        ...state,
        updatingConfig: true,
      };
    case paymentConfigTypes.UPDATE_PAYMENT_CONFIG_SUCCESS:
      return {
        ...state,
        updatingConfig: false,
      };
    case paymentConfigTypes.UPDATE_PAYMENT_CONFIG_FAILURE:
      return {
        ...state,
        updatingConfig: false,
        error: payload,
      };
    default:
      return state;
  }
}

export default workflowsReducer;
